import { Component } from '@angular/core';

@Component({
  selector: 'app-floating-elements',
  standalone: true,
  imports: [],
  templateUrl: './floating-elements.component.html',
  styleUrl: './floating-elements.component.scss'
})
export class FloatingElementsComponent {

}
